import React from 'react';
import PropTypes from 'prop-types';
import {useIntl} from 'react-intl';


import * as emailFormConstants from '../emailFormConstants';
import * as emailConfirmationFormConstants from './emailConfirmationFormConstants';

import {inputConstants} from '../../../global/Form/Input';

import FormTextInput from '../../../global/Form/FormElement/FormTextInput';
import ValidatingForm from '../../../global/Form/ValidatingForm';


function EmailConfirmationForm({data, onChange}) {

    const {formatMessage} = useIntl();

    return (
        <ValidatingForm
            data={data}
            id={'email.form'}
            onIsInvalid={data => onChange(data, false)}
            onIsValid={data => onChange(data, true)}
            validationSchema={emailConfirmationFormConstants.SCHEMA_EMAIL_CONFIRMATION_FORM}
        >
            {({form}) => (
                <>
                    <FormTextInput
                        autocomplete={inputConstants.AUTOCOMPLETE_EMAIL}
                        error={form.getCurrentError('email')}
                        id={'email'}
                        isRequired={form.isRequired('email')}
                        label={formatMessage({id: 'email.form.field.email.label'})}
                        maxLength={emailFormConstants.EMAIL_MAX_LENGTH}
                        name={'email'}
                        onChange={email => form.setData({email})}
                        placeholder={formatMessage({id: 'email.form.field.email.placeholder'})}
                        type={inputConstants.TYPE_EMAIL}
                        value={form.getData('email')}
                    />

                    <FormTextInput
                        autocomplete={inputConstants.AUTOCOMPLETE_EMAIL}
                        error={form.getCurrentError('emailConfirmation')}
                        id={'emailConfirmation'}
                        isRequired={form.isRequired('emailConfirmation')}
                        label={formatMessage({id: 'email.form.field.emailConfirmation.label'})}
                        maxLength={emailFormConstants.EMAIL_MAX_LENGTH}
                        name={'emailConfirmation'}
                        onChange={emailConfirmation => form.setData({emailConfirmation})}
                        placeholder={formatMessage({id: 'email.form.field.emailConfirmation.placeholder'})}
                        type={inputConstants.TYPE_EMAIL}
                        value={form.getData('emailConfirmation')}
                    />
                </>
            )}
        </ValidatingForm>
    );
}


EmailConfirmationForm.propTypes = {
    data: PropTypes.object,
    onChange: PropTypes.func.isRequired
};


export default EmailConfirmationForm;
